import {
  faUser,
  faChalkboardUser,
  faRectangleList,
  faCertificate,
  faBriefcase,
  faGraduationCap,
  faFilePdf,
  faUserSecret,
  faSitemap,
  faBuilding,
  faFile,
  faFileAlt,
  faFileSignature,
  faMoneyBill,
  faChartBar,
  faTasks,
  faPeopleGroup,
  faCogs,
  faFlask,
  faCalendarAlt,
  faCreditCard,
  faUserTie,
  faTh,
  faChalkboardTeacher,
  faIdCard,
  faShieldHalved,
  faEye,
  faMagnifyingGlass,
  faSignOutAlt,
  faCalendar,
  faUsers,
  faGear,
  faHandshake,
  faCalendarPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OrganizationAutocomplete } from "@/pages/organizationDashboard/components/OrganizationAutoSelect";
import { TrainingOrgAutocomplete } from "@/pages/eventManagement/components/TrainingOrgAutocomplete";
import {
  canManageTrainingOrgUsers,
  hasTrainingOrgAccess,
} from "@/utils/orgPermissions";
import { TrainingOrgRptAutocomplete } from "@/pages/reports/components/TrainingOrgRptAutocomplete";
import { ProgramAutocomplete } from "@/pages/reports/components/ProgramAutocomplete";
import { baseURL } from "@/services/http";
import { FeatureFlags } from "./featureFlags";

export const getLogoutMenuItems = () => {
  return [
    {
      text: "Logout",
      icon: <FontAwesomeIcon icon={faSignOutAlt} size="lg" />,
      customNavHandler: () => {
        window.location = `${baseURL}user/logout?message=genericSignOut`;
      },
    },
  ];
};

export const getMenuItems = (applicationsMenu, forceDisable) => {
  return [
    {
      text: "My Account",
      icon: <FontAwesomeIcon icon={faUser} size="lg" />,
      // navPath: "/account",
      disabled: forceDisable,
      expandOnClick: true,
      subItems: [
        {
          text: "Account",
          icon: <FontAwesomeIcon icon={faUser} size="lg" />,
          navPath: "/account",
          disabled: forceDisable,
          expandOnClick: true,
          subItems: [
            {
              text: "1099 Forms",
              icon: <FontAwesomeIcon icon={faFile} color={"white"} size="lg" />,
              navPath: `/account/1099`,
              disabled: forceDisable,
            },
            {
              text: "Request Background Check",
              icon: (
                <FontAwesomeIcon
                  icon={faUserSecret}
                  color={"white"}
                  size="lg"
                />
              ),
              navPath: `${baseURL}user/SubmitBackgroundCheck`,
              disabled: forceDisable,
            },
          ],
        },
        {
          text: "Applications",
          icon: <FontAwesomeIcon icon={faRectangleList} size="lg" />,
          navPath: "/applications",
          subItems: applicationsMenu,
          disabled: forceDisable,
          expandOnClick: true,
        },
        {
          text: "Credentials",
          icon: <FontAwesomeIcon icon={faCertificate} size="lg" />,
          navPath: "/credentials",
          disabled: forceDisable,
        },
        {
          text: "Education",
          icon: <FontAwesomeIcon icon={faGraduationCap} size="lg" />,
          navPath: "/education",
          disabled: forceDisable,
        },
        {
          text: "Employment",
          icon: <FontAwesomeIcon icon={faBriefcase} size="lg" />,
          navPath: "/employment",
          disabled: forceDisable,
        },
        // Temporarily disable this until client wants to turn it back on or we decide to remove it all together
        // the PD Event Registration home page is also rerouting to the PWA home page
        // {
        //   text: "PD Event Registration",
        //   icon: <FontAwesomeIcon icon={faCalendarDay} size="lg" />,
        //   navPath: "/pdEventRegistration",
        //   disabled: forceDisable,
        // },
        {
          text: "Professional Development",
          icon: <FontAwesomeIcon icon={faChalkboardUser} size="lg" />,
          navPath: "/professionalDevelopment",
          disabled: forceDisable,
        },
      ],
    },
  ];
};

export const getReportBuilder = ({
  user,
  reportPermissions,
  queuedReports,
}) => {
  const { permissions } = user;
  const {
    pdtrack_data_entry,
    registry_admin,
    dip_admin,
    dip_management,
    ocaf_agency_admin,
    organization_owners,
    organization_directors,
  } = permissions;

  const reportsMenu = [];
  const reportsPanel = {
    text: "Reports",
    icon: <FontAwesomeIcon icon={faFilePdf} size="lg" />,
    subItems: [],
    expandOnClick: true,
  };
  const profileReports = {
    text: "My Reports",
    subItems: [],
    expandOnClick: true,
  };
   profileReports.subItems.push({
    text: "Current Career Pathways Summary",
    navPath: `${baseURL}reports/reg_cp_profile_summary/${user.user_id}`,
    additionalInfo:
      "View a detailed breakdown of your current biennium Career Pathways Level points.",
  });
  profileReports.subItems.push({
    text: "Profile Training Summary",
    navPath: `${baseURL}reports/training_summary/${user.user_id}`,
    additionalInfo:
      "View a detailed report of Ohio Approved, Non-Ohio Approved Professional Development and Health and Safety courses verified in your profile.",
  });
  profileReports.subItems.push({
    text: "CDA Registry Transcript",
    navPath: `${baseURL}reports/cda_area/${user.user_id}`,
    additionalInfo:
      "The CDA Registry Transcript Report includes all qualifying Instructor Submitted Ohio Approved PD Events that align to specific CDA content areas and qualifying CDA Subject Area 4: To establish and maintain a safe, healthy learning environment. Please Note: School-Age PD Events are not included in the CDA Registry Transcript because they do not meet any CDA content areas. The CDA Registry Transcript may be submitted with a CDA Credential application.",
  });
  if (reportPermissions.odh_hv) {
    profileReports.subItems.push({
      text: "Home Visitor Registry Transcript",
      navPath: `${baseURL}reports/hv_transcript/${user.user_id}`,
      additionalInfo:
        "View your Home Visiting Professional Development Transcript of verified trainings in the Ohio Professional Registry completed since the issue date of your current Home Visiting Credential(s).  This report supports tracking the required professional development needed to renew your credential(s).",
    });
  }
  profileReports.subItems.push({
    text: "SUTQ Professional Development Report",
    navPath: `${baseURL}reports/sutq_training_report/${user.user_id}`,
    additionalInfo:
      "Program Summary and Program Detail Reports for SUTQ. Authorized OCCRRA, ODE and ODJFS employees have access to these reports for SUTQ inspections.",
  });
  if (reportPermissions.special) {
    profileReports.subItems.push({
      text: "SUTQ Program Reports",
      navPath: `/reports/sutq_reports`,
      additionalInfo:
        "Program Summary and Program Detail Reports for SUTQ. Authorized OCCRRA, ODE and ODJFS employees have access to these reports for SUTQ inspections.",
    });
  }
  if (profileReports.subItems.length > 0) {
    reportsPanel.subItems.push(profileReports);
  }
  if (registry_admin) {
    const adminReports = {
      text: "OPR Admin Reports",
      navPath: `/reports/admin-reports`,
    };
    reportsPanel.subItems.push(adminReports);
  }
  if (queuedReports) {
    const reportsQueue = {
      text: "Queued Reports",
      navPath: `/reports/queue`,
    };
    reportsPanel.subItems.push(reportsQueue);
  }

  if (
    dip_admin ||
    dip_management ||
    organization_owners ||
    organization_directors ||
    ocaf_agency_admin
  ) {
    const orgReports = {
      text: "Program Reports",
      subItems: [
        {
          text: "",
          component: <ProgramAutocomplete />,
        },
      ],
      expandOnClick: true,
    };

    reportsPanel.subItems.push(orgReports);
  }

  if (pdtrack_data_entry) {
    const trainingOrgReports = {
      text: "Training Organization Reports",
      subItems: [
        {
          text: "",
          component: <TrainingOrgRptAutocomplete />,
        },
      ],
      expandOnClick: true,
    };
    reportsPanel.subItems.push(trainingOrgReports);
  }

  if (reportsPanel.subItems?.length > 0) {
    reportsMenu.push(reportsPanel);
  }

  return reportsMenu;
};

export const getAdminMenuItems = (
  user,
  organizationProfile,
  trainingOrg,
  forceDisable,
  isFeatureEnabled,
  permissionsByTrainingOrg
) => {
  if (!user || !user.permissions) return [];
  const { permissions } = user;
  const {
    can_user_navigate_to_containerized_erc,
    can_user_navigate_to_erc,
    dip_admin,
    dip_management,
    fc_admins,
    ocaf_agency_admin,
    odjfs_erc_lic_super,
    organization_directors,
    organization_owners,
    organization_management_system,
    pdtrack_data_entry_21000013,
    pdtrack_data_entry_21000019,
    pdtrack_data_entry_21000099,
    pdtrack_data_entry_21004585,
    pdtrack_data_entry_21063282,
    pdtrack_data_entry_21068351,
    qrtp_admins,
    registry_admin,
    registry_functions,
    ta_module,
    pdtrack_data_entry,
    pdtrack_payment_system,
    quarterly_reporting,
  } = permissions;

  const hasPermission = (seekingPermission) => {
    if (user.is_admin) {
      return true;
    }
    if (!permissionsByTrainingOrg?.org_permissions) {
      return false;
    }
    return (
      permissionsByTrainingOrg.org_permissions.indexOf(seekingPermission) > -1
    );
  };

  const adminPanel = {
    text: "Organizations",
    icon: <FontAwesomeIcon icon={faShieldHalved} size="lg" />,
    subItems: [],
    disabled: forceDisable,
    expandOnClick: true,
  };
  if (can_user_navigate_to_containerized_erc || can_user_navigate_to_erc) {
    const queryString = can_user_navigate_to_containerized_erc
      ? "&containerized=true"
      : "";
    adminPanel.subItems.push({
      text: "Employee Record Chart",
      icon: <FontAwesomeIcon icon={faSitemap} size="lg" />,
      navPath: `${baseURL}erc?from=pwa${queryString}`,
      disabled: forceDisable,
    });
  }
  if (pdtrack_data_entry || odjfs_erc_lic_super) {
    if (isFeatureEnabled(FeatureFlags.UPDATED_EM)) {
      const trainingOrgDashboard = {
        text: "Event Management",
        icon: <FontAwesomeIcon icon={faGraduationCap} size="lg" />,
        component: <TrainingOrgAutocomplete />,
        disabled: forceDisable,
      };
      if (trainingOrg) {
        // Users who can edit this org's trainings get the full menu. ERC supervisors,
        // statewide or county, can also manage the org's users; those who cannot edit
        // its trainings only reach this menu for that, so it is the only sub item.
        const usersPageOnly = !hasTrainingOrgAccess(user, permissionsByTrainingOrg);
        const canManageUsers = canManageTrainingOrgUsers(
          user,
          permissionsByTrainingOrg
        );
        const userPermissions = {
          text: "User Permissions",
          icon: <FontAwesomeIcon icon={faUsers} size="lg" />,
          navPath: `/eventManagement/${trainingOrg.id}/users`,
          // forceDisable means "no employment record", which has no bearing on an
          // ERC supervisor's ability to manage their own org's users
          disabled: (forceDisable && !usersPageOnly) || !canManageUsers,
        };
        trainingOrgDashboard.subItems = usersPageOnly
          ? [userPermissions]
          : [
              {
                text: "Events",
                icon: <FontAwesomeIcon icon={faCalendar} size="lg" />,
                navPath: `/eventManagement/${trainingOrg.id}/events`,
                disabled: forceDisable,
              },
              {
                text: "Instructors",
                icon: <FontAwesomeIcon icon={faGraduationCap} size="lg" />,
                navPath: `/eventManagement/${trainingOrg.id}/instructors`,
                disabled: forceDisable,
              },
              {
                text: "Organization Settings",
                icon: <FontAwesomeIcon icon={faGear} size="lg" />,
                navPath: `/organizationManager/${trainingOrg.id}/edit`,
                disabled: forceDisable,
              },
              {
                text: "Scheduled Events",
                icon: <FontAwesomeIcon icon={faCalendarPlus} size="lg" />,
                navPath: `/eventManagement/${trainingOrg.id}/scheduledEvents`,
                disabled: forceDisable,
              },
              {
                text: "Sharing",
                icon: <FontAwesomeIcon icon={faHandshake} size="lg" />,
                navPath: `/eventManagement/${trainingOrg.id}/sharing`,
                disabled: forceDisable,
              },
              userPermissions,
            ];
      }
      adminPanel.subItems.push(trainingOrgDashboard);
    } else if (pdtrack_data_entry) {
      // The legacy dashboard is training org work, so it stays data entry only
      adminPanel.subItems.push({
        text: "Training Org. Dashboard",
        icon: <FontAwesomeIcon icon={faGraduationCap} size="lg" />,
        navPath: `${baseURL}training_organization?from=pwa`,
        disabled: forceDisable,
      });
    }
  }
  if (
    dip_admin ||
    dip_management ||
    organization_owners ||
    organization_directors ||
    ocaf_agency_admin
  ) {
    const orgDashboard = {
      text: "Program Management",
      icon: <FontAwesomeIcon icon={faBuilding} size="lg" />,
      component: <OrganizationAutocomplete />,
      disabled: forceDisable,
      expandOnClick: true,
    };
    if (organizationProfile) {
      orgDashboard.subItems = getOrganizationDashboardSubItems(
        organizationProfile,
        forceDisable
      );
    }
    adminPanel.subItems.push(orgDashboard);
  }

  const oprAdmin = {
    text: "Administration",
    icon: <FontAwesomeIcon icon={faEye} size="lg" />,
    subItems: [],
    disabled: forceDisable,
    expandOnClick: true,
  };
  if (
    registry_functions ||
    fc_admins ||
    pdtrack_data_entry_21063282 ||
    qrtp_admins
  ) {
    const oprAdminApps = {
      text: "Applications",
      icon: <FontAwesomeIcon icon={faRectangleList} size="lg" />,
      subItems: [],
      disabled: forceDisable,
      expandOnClick: true,
    };
    if (registry_functions || pdtrack_data_entry_21063282) {
      oprAdminApps.subItems.push({
        text: "App Queue",
        icon: <FontAwesomeIcon icon={faTasks} size="lg" />,
        navPath: `/admin/applications/appQueue`,
        disabled: forceDisable,
      });
    }
    if (registry_functions) {
      oprAdminApps.subItems.push({
        text: "Events Queue",
        icon: <FontAwesomeIcon icon={faFileSignature} size="lg" />,
        navPath: `/admin/applications/eventsQueue`,
        disabled: forceDisable,
      });
    }
    /*
        if (fc_admins) {
          oprAdminApps.subItems.push({
            text: "Foster Care",
            icon: <FontAwesomeIcon icon={faChildren} size="lg"/>,
            navPath: `${baseURL}admin/fc_applications`,
            disabled: forceDisable,
          });
        }
    */
    if (registry_functions) {
      oprAdminApps.subItems.push({
        text: "Mentorship",
        icon: <FontAwesomeIcon icon={faPeopleGroup} size="lg" />,
        navPath: `${baseURL}admin/mentor_applications`,
        disabled: forceDisable,
      });
    }
    if (registry_functions) {
      oprAdminApps.subItems.push({
        text: "OHP",
        icon: <FontAwesomeIcon icon={faFileSignature} size="lg" />,
        navPath: `${baseURL}admin/ohp_applications`,
        disabled: forceDisable,
      });
    }
    /*
        if (registry_functions) {
          oprAdminApps.subItems.push({
            text: "Pandemic",
            icon: <FontAwesomeIcon icon={faFileSignature} size="lg"/>,
            navPath: `${baseURL}admin/pandemic_applications`,
            disabled: forceDble,
          });
        }
    /*
        if (qrtp_admins) {
          oprAdminApps.subItems.push({
            text: "QRTP",
            icon: <FontAwesomeIcon icon={faQrcode} size="lg"/>,
            navPath: `${baseURL}admin/qrtp_applications`,
            disabled: forceDisable,
          });
        }
    */
    if (registry_functions) {
      oprAdminApps.subItems.push({
        text: "Stabilization",
        icon: <FontAwesomeIcon icon={faFileSignature} size="lg" />,
        navPath: `${baseURL}admin/stabilization_apps`,
        disabled: forceDisable,
      });
    }
    oprAdmin.subItems.push(oprAdminApps);
  }
  if (organization_management_system) {
    oprAdmin.subItems.push({
      text: "Organization Manager",
      icon: <FontAwesomeIcon icon={faSitemap} size="lg" />,
      navPath: `${baseURL}admin/manage_organizations`,
      // navPath: `/organizationManager`,
      disabled: forceDisable,
    });
  }
  if (pdtrack_payment_system) {
    oprAdmin.subItems.push({
      text: "Payment System",
      icon: <FontAwesomeIcon icon={faMoneyBill} size="lg" />,
      navPath: `${baseURL}payment`,
      disabled: forceDisable,
    });
  }
  if (quarterly_reporting) {
    oprAdmin.subItems.push({
      text: "Quarterly Reporting",
      icon: <FontAwesomeIcon icon={faChartBar} size="lg" />,
      navPath: `${baseURL}quarterly_reporting`,
      disabled: forceDisable,
    });
  }
  if (registry_functions) {
    const oprAdminReg = {
      text: "Registry",
      icon: <FontAwesomeIcon icon={faEye} size="lg" />,
      subItems: [],
      disabled: forceDisable,
      expandOnClick: true,
    };
    oprAdminReg.subItems = [
      {
        text: "Admin Options",
        icon: <FontAwesomeIcon icon={faFlask} size="lg" />,
        navPath: `${baseURL}admin/admin_options`,
        disabled: forceDisable,
      },
      {
        text: "Document Verification",
        icon: <FontAwesomeIcon icon={faFileAlt} size="lg" />,
        navPath: "/documentVerification",
        disabled: forceDisable,
      },
      {
        text: "Document Verification - Old",
        icon: <FontAwesomeIcon icon={faFileAlt} size="lg" />,
        navPath: `${baseURL}admin/verify_new`,
        disabled: forceDisable,
      },
      {
        text: "Professional Manager",
        icon: <FontAwesomeIcon icon={faUserTie} size="lg" />,
        navPath: `${baseURL}user/manage_permissions`,
        disabled: forceDisable,
      },
    ];
    oprAdmin.subItems.push(oprAdminReg);
  }
  if (registry_admin || user.is_admin || ocaf_agency_admin) {
    oprAdmin.subItems.push({
      text: "OCAF Admin Group",
      icon: <FontAwesomeIcon icon={faUsers} size="lg" />,
      navPath: `/admin/ocaf-admin-group`,
      disabled: forceDisable,
    });
  }
  if (ta_module) {
    oprAdmin.subItems.push({
      text: "Technical Assistance Module",
      icon: <FontAwesomeIcon icon={faCogs} size="lg" />,
      navPath: `${baseURL}ta_module/index/1`,
      disabled: forceDisable,
    });
  }
  if (registry_functions) {
    const oprAdminWf = {
      text: "Workforce",
      icon: <FontAwesomeIcon icon={faPeopleGroup} size="lg" />,
      subItems: [],
      disabled: forceDisable,
      expandOnClick: true,
    };
    oprAdminWf.subItems = [
      {
        text: "POWER Ohio Dashboard",
        icon: <FontAwesomeIcon icon={faFileSignature} size="lg" />,
        navPath: `${baseURL}apps/powers/admin`,
        disabled: forceDisable,
      },
      {
        text: "TEACH Ohio Dashboard",
        icon: <FontAwesomeIcon icon={faFileSignature} size="lg" />,
        navPath: `${baseURL}admin/teach_apps`,
        disabled: forceDisable,
      },
      {
        text: "Compass Dashboard",
        icon: <FontAwesomeIcon icon={faFileSignature} size="lg" />,
        navPath: `${baseURL}admin/compass_apps`,
        disabled: forceDisable,
      },
    ];
    oprAdmin.subItems.push(oprAdminWf);
  }

  // build top level admin menu
  const adminMenu = [];
  if (adminPanel.subItems.length > 0) {
    adminMenu.push(adminPanel);
  }
  if (oprAdmin.subItems.length > 0) {
    adminMenu.push(oprAdmin);
  }
  adminMenu.push({
    text: "Training Search",
    icon: <FontAwesomeIcon icon={faMagnifyingGlass} size="lg" />,
    navPath: "/trainingSearch",
    disabled: forceDisable,
  });
  return adminMenu;
};

const getOrganizationDashboardSubItems = (
  organizationProfile,
  forceDisable
) => {
  if (!organizationProfile) {
    return null;
  }
  const { org_type: orgType, organization_id_hash, info } = organizationProfile;
  const { oin: organization_id } = info;
  const subItems = [];
  if (orgType === "org") {
    if (info?.center_type === "OCAF") {
      subItems.push({
        text: "Employees",
        icon: <FontAwesomeIcon icon={faUserTie} size="lg" />,
        navPath: `/organizationDashboard/${organization_id}/employees`,
        disabled: forceDisable,
      });
    } else {
      subItems.push({
        text: "Applications",
        icon: <FontAwesomeIcon icon={faTh} size="lg" />,
        navPath: `/organizationDashboard/${organization_id}/applications`,
        disabled: forceDisable,
      });
      subItems.push({
        text: "Background Notifications",
        icon: <FontAwesomeIcon icon={faIdCard} size="lg" />,
        navPath: `${baseURL}organization_profile/bc_notifications/${organization_id_hash}?from=pwa`,
        disabled: forceDisable,
      });
      subItems.push({
        text: "Employees",
        icon: <FontAwesomeIcon icon={faUserTie} size="lg" />,
        navPath: `/organizationDashboard/${organization_id}/employees`,
        disabled: forceDisable,
      });
      subItems.push({
        text: "Groups",
        icon: <FontAwesomeIcon icon={faChalkboardTeacher} size="lg" />,
        navPath: `${baseURL}organization_profile/classrooms/${organization_id_hash}?from=pwa`,
        disabled: forceDisable,
      });
      subItems.push({
        text: "Payments",
        icon: <FontAwesomeIcon icon={faCreditCard} size="lg" />,
        navPath: `/organizationDashboard/${organization_id}/payments`,
        disabled: forceDisable,
      });
      subItems.push({
        text: "Staff Schedules",
        icon: <FontAwesomeIcon icon={faCalendarAlt} size="lg" />,
        navPath: `${baseURL}organization_profile/staff_schedules/${organization_id_hash}?from=pwa`,
        disabled: forceDisable,
      });
    }
  } else if (orgType === "qrtp") {
    subItems.push({
      text: "Applications",
      icon: <FontAwesomeIcon icon={faTh} size="lg" />,
      navPath: `/organizationDashboard/${organization_id}/applications`,
      disabled: forceDisable,
    });
  } else if (orgType === "rise" || orgType === "dodd" || orgType === "odh") {
    subItems.push({
      text: "Employees",
      icon: <FontAwesomeIcon icon={faUserTie} size="lg" />,
      navPath: `/organizationDashboard/${organization_id}/employees`,
      disabled: forceDisable,
    });

/*
    subItems.push({
      text: "Reports",
      icon: <FontAwesomeIcon icon={faFileAlt} size="lg" />,
      navPath: `/organizationDashboard/${organization_id}/reports`,
      disabled: forceDisable,
    });
*/
  }
  return subItems;
};
